import { StylesConfig } from 'react-select';
import { OptionType } from 'components/CustomSelect/types';

const allocationMethodListStyles: StylesConfig<OptionType, false> = {
  option: styles => ({
    ...styles,
    padding: '4.8px 12px',
  }),
};

export default allocationMethodListStyles;
